import React from 'react';
import { FadeIn } from '../ui/FadeIn';
import { CheckCircle2, XCircle } from 'lucide-react';
const isFor = ["Mujeres de 65+ que han sentido 'lagunas' mentales recientemente y quieren frenarlas.", 'Abuelas que quieren estar 100% presentes y lúcidas para sus nietos y familia.', 'Mujeres independientes que manejan su hogar y sus finanzas y no piensan delegar ese poder.', 'Personas que buscan un método natural, preventivo y sin efectos secundarios.'];
const isNotFor = ['Personas con un diagnóstico avanzado de Alzheimer o demencia clínica severa.', "Quienes buscan una 'pastilla mágica' sin dedicar 15 minutos de práctica al día.", 'Personas que no tienen interés en mejorar su calidad de vida actual.'];
export function ForWhom() {
  return <section className="bg-white py-24 md:py-32 px-6" data-id="element-69">
      <div className="max-w-6xl mx-auto" data-id="element-70">
        <div className="grid md:grid-cols-2 gap-12 md:gap-8" data-id="element-71">
          {/* Who this is for */}
          <FadeIn data-id="element-72">
            <div className="bg-cream-50 rounded-3xl p-8 md:p-12 border border-cream-200 h-full" data-id="element-73">
              <h3 className="font-serif text-2xl md:text-3xl text-navy-900 font-bold mb-8 flex items-center gap-3" data-id="element-74">
                <span className="bg-green-100 text-green-700 p-2 rounded-full" data-id="element-75">
                  <CheckCircle2 className="w-6 h-6" data-id="element-76" />
                </span>
                Para quién es esto
              </h3>
              <ul className="space-y-6" data-id="element-77">
                {isFor.map((item, index) => <li key={index} className="flex items-start gap-4" data-id="element-78">
                    <div className="mt-1.5 w-2 h-2 rounded-full bg-gold-500 shrink-0" data-id="element-79" />
                    <p className="text-lg md:text-xl text-charcoal-800 leading-relaxed" data-id="element-80">
                      {item}
                    </p>
                  </li>)}
              </ul>
            </div>
          </FadeIn>

          {/* Who this is NOT for */}
          <FadeIn delay={0.2} data-id="element-81">
            <div className="bg-gray-50 rounded-3xl p-8 md:p-12 border border-gray-200 h-full" data-id="element-82">
              <h3 className="font-serif text-2xl md:text-3xl text-charcoal-900 font-bold mb-8 flex items-center gap-3" data-id="element-83">
                <span className="bg-red-100 text-red-700 p-2 rounded-full" data-id="element-84">
                  <XCircle className="w-6 h-6" data-id="element-85" />
                </span>
                Para quién NO es
              </h3>
              <ul className="space-y-6" data-id="element-86">
                {isNotFor.map((item, index) => <li key={index} className="flex items-start gap-4 opacity-80" data-id="element-87">
                    <div className="mt-1.5 w-2 h-2 rounded-full bg-gray-400 shrink-0" data-id="element-88" />
                    <p className="text-lg md:text-xl text-charcoal-700 leading-relaxed" data-id="element-89">
                      {item}
                    </p>
                  </li>)}
              </ul>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}